<template>
  <b-card class="reason-card">
    <h3>Motivo Detalhado:</h3>

    <ul>
      <li
        v-for="(reason, index) in reasons"
        :key="index"
      >
        {{ reason }}
      </li>
    </ul>
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'

export default {
  name: 'PreAnalysisReason',

  components: {
    BCard
  },

  props: {
    reasons: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped>
.reason-card {
  border: 0;
  border-radius: 8px;
  margin-bottom: 14px;
}

.reason-card h3 {
  margin: 0 0 4px;
  font-size: 18px;
  font-weight: 600;
}

.reason-card ul {
  margin: 0;
  padding-left: 22px;
  font-size: 15px;
  line-height: 1.55;
}

.reason-card li {
  padding-left: 2px;
}
</style>